import { createContext } from 'react'

const FocusTrapContext = createContext(null)

export default FocusTrapContext
